import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DRAFT_STATUS } from 'core/helpers/policy-drafting';
import useStyles from './status-pill.styles';

const DRAFT_STATUS_PILL = {
  [DRAFT_STATUS.WORKING]: { label: 'Working', tone: 'orange' },
  [DRAFT_STATUS.IN_REVIEW]: { label: 'In review', tone: 'blue' },
  [DRAFT_STATUS.CHANGES_REQUESTED]: { label: 'Changes requested', tone: 'yellow' },
  [DRAFT_STATUS.APPROVED]: { label: 'Approved', tone: 'green' },
  [DRAFT_STATUS.DENIED]: { label: 'Denied (view-only)', tone: 'red' },
  [DRAFT_STATUS.DELETED]: { label: 'Deleted (view-only)', tone: 'grey' }
};

/** Without a status, the pill stands for the official policy and only says it is view-only. */
const StatusPill = ({ status, viewOnly, className }) => {
  const classes = useStyles();
  if (!status) {
    return <span className={classNames(classes.pill, classes.grey, className)}>View-only</span>;
  }
  const { label, tone } = DRAFT_STATUS_PILL[status];
  return (
    <span className={classNames(classes.pill, classes[tone], className)}>
      {viewOnly ? `${label} (view-only)` : label}
    </span>
  );
};

StatusPill.propTypes = {
  status: PropTypes.oneOf(Object.keys(DRAFT_STATUS_PILL)),
  viewOnly: PropTypes.bool,
  className: PropTypes.string
};

StatusPill.defaultProps = {
  status: null,
  viewOnly: false,
  className: null
};

export default StatusPill;
